import React, { useEffect, useState } from 'react';
import CourseCard from './CourseCard';
import { useInsertName } from "./utils/helpers";
import { PaperBG, MonoButton, UnderlineSketch } from '../kits';
import { Link } from 'react-router-dom';

function PopularCourses({ setFavoriteCourses }) {
  const [courses, setCourses] = useState([]);
  const name = useInsertName();

  const fetchCourses = () => {
    const cacheBuster = `?_=${new Date().getTime()}`;
    fetch(`https://www.denisbitter.de/stage01/api/get_courses.php${cacheBuster}`)
      .then((response) => {
        if (!response.ok) throw new Error('Fehler beim Laden der Kursdaten');
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          const favoriteCourses = data.data.filter(course => String(course.isFavorite) === "1");
          setCourses(favoriteCourses);
          if (setFavoriteCourses) setFavoriteCourses(favoriteCourses);
        } else {
          throw new Error(data.message || "Unbekannter Fehler bei der API");
        }
      })
      .catch((error) => console.error('Fehler beim Laden der Kursdaten:', error));
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  return (
    <PaperBG>
      <section className="py-16 border-t border-black font-mono">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-sm md:text-sm font-normal mb-4 relative inline-block text-brand">
            Projekt-Kurse für dein Wissen,{" "}
            <span className="relative inline-block">
              {name}
              <span className="absolute left-0 bottom-[-0.2rem] w-full h-2">
                <UnderlineSketch color="zenBrand" />
              </span>
            </span>
          </h2>

          <h3 className="text-base md:text-base font-normal pb-10">
            Web Entwicklung, Design UI und 2D & 3D Content
          </h3>

          <p className="text-sm text-gray-700 mb-8">
            <span className="text-brand   px-1 py-0">
              Erlerne echtes Wissen aus der Praxis
            </span>
          </p>

          {courses.length > 0 ? (
            <div
              className={`
                ${courses.length === 1
                  ? "flex justify-center"
                  : "grid md:grid-cols-2 auto-rows-fr"}
                gap-8 pt-10
              `}
            >
           {courses.map((course) => (
  <div
    key={course.id}
    className="w-full max-w-md mx-auto h-full"
  >
    <CourseCard course={course} className="min-h-[560px] ambilight-border-2" />
  </div>
))}
            </div>
          ) : (
            <div className="col-span-full text-center py-8">
              <p className="text-gray-600 text-xs mb-4">
                Leider keine beliebten Kurse verfügbar.
              </p>
            </div>
          )}

          <div className="mt-8">
            <Link to="/courses">
              <MonoButton 
              
              
              className="px-6 py-2 text-xs max-w-screen-lg"
              underlineColors='ZenAmber'
              textColor='text-amber-100'
              
              
              >
                Zeige mir andere Kurse
              </MonoButton>
            </Link>
          </div>
        </div>
      </section>
    </PaperBG>
  );
}

export default PopularCourses;
